export default {
  label: {
    filter: 'publicações owned e earned',
  },
};
